import { Navigate, useLocation } from 'react-router-dom';
import { normalizeRole } from '@/auth/permissions';
import { clearSession, getSession } from '@/lib/session';

type RhMode = 'admin' | 'employee';

type RequireRhRoleProps = {
  mode: RhMode;
  children: JSX.Element;
};

export function RequireRhRole({ mode, children }: RequireRhRoleProps) {
  const location = useLocation();
  const session = typeof window !== 'undefined' ? getSession() : null;

  if (!session?.token || !session?.user) {
    if (typeof window !== 'undefined') {
      clearSession();
    }
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const role = normalizeRole(session.user.role);

  if (role === 'CONSULTA') {
    return <Navigate to="/inventario" replace />;
  }

  if (mode === 'admin') {
    return role === 'ADMIN' || role === 'RH' ? children : <Navigate to="/solicitudes" replace />;
  }

  if (role === 'ADMIN') {
    return <Navigate to="/admin/rh/aprobaciones" replace />;
  }
  return children;
}

export function RhAsistenciaRedirect() {
  const session = typeof window !== 'undefined' ? getSession() : null;
  const role = normalizeRole(session?.user?.role);

  if (role === 'CONSULTA') {
    return <Navigate to="/inventario" replace />;
  }
  if (role === 'ADMIN') {
    return <Navigate to="/admin/rh/asistencia" replace />;
  }
  if (role === 'RH') {
    return <Navigate to="/asistencia" replace />;
  }
  return <Navigate to="/asistencia" replace />;
}

export function RhSolicitudesRedirect() {
  const location = useLocation();
  const session = typeof window !== 'undefined' ? getSession() : null;

  if (!session?.token || !session?.user) {
    if (typeof window !== 'undefined') {
      clearSession();
    }
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const role = normalizeRole(session.user.role);
  if (role === 'CONSULTA') {
    return <Navigate to="/inventario" replace />;
  }
  if (role === 'ADMIN' || role === 'RH') {
    return <Navigate to="/admin/rh/aprobaciones" replace />;
  }
  return <Navigate to="/solicitudes" replace />;
}

export function RhAprobacionesRedirect() {
  const location = useLocation();
  const session = typeof window !== 'undefined' ? getSession() : null;

  if (!session?.token || !session?.user) {
    if (typeof window !== 'undefined') {
      clearSession();
    }
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const role = normalizeRole(session.user.role);
  if (role === 'CONSULTA') {
    return <Navigate to="/inventario" replace />;
  }
  if (role === 'ADMIN' || role === 'RH') {
    return <Navigate to="/admin/rh/aprobaciones" replace />;
  }
  return <Navigate to="/solicitudes" replace />;
}
